module.exports = __webpack_public_path__ + "static/media/2C295DC6-63F6-4CF3-AF49-FBE11B094361.8b5f91d8.jpeg";